import '../../vendor/default'
import * as web from './common/web'
import { router } from './routes'

import '../styles/index.scss'

if ('find' in Array.prototype) {
    run()
} else {
    import('../../vendor/pollyfill').then(() => {
        run()
    })
}

function run() {
    const unsupported =
        document.documentElement.getAttribute('unsupported') === 'true'
    web.init()
    window.flipp.start = start
    // @ts-ignore
    if (
        window.flipp &&
        typeof flipp === 'object' &&
        typeof flipp.start === 'function' &&
        !unsupported
    ) {
        try {
            // @ts-ignore
            flipp.start()
        } catch (e) {
            console.log(e)
            // @ts-ignore
            displayWarning()
        }
    } else {
        // @ts-ignore
        displayWarning()
    }
}

function start() {
    web.go(router)
}
